module.exports = __webpack_public_path__ + "static/media/low.00ba1b64.ogg";